import React, { useState } from 'react';
import { PackageIcon } from 'lucide-react';
import { ReturnDetailsModal } from './ReturnDetailsModal';
export function ReturnsSection() {
  const [selectedReturn, setSelectedReturn] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const returns = [{
    id: '#RET-2025-00012',
    originalOrderId: '#000013951',
    returnDate: '2024-01-16',
    status: 'approved' as const,
    reason: 'Product damaged',
    refundMethod: 'Original Payment Method',
    refundAmount: 12.99,
    items: [{
      name: 'Panadol Extra Tablets 24s',
      quantity: 1,
      price: 12.99,
      image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop'
    }],
    trackingNumber: 'TRK-2024-001234',
    estimatedRefundDate: '2024-01-20'
  }, {
    id: '#RET-2025-00011',
    originalOrderId: '#000013948',
    returnDate: '2024-01-12',
    status: 'pending' as const,
    reason: 'Wrong item received',
    refundMethod: 'Store Credit',
    refundAmount: 24.99,
    items: [{
      name: 'Vitamin D3 1000 IU Supplement 60 Capsules',
      quantity: 1,
      price: 24.99,
      image: 'https://images.unsplash.com/photo-1550572017-4bfa2d5c8f1d?w=400&h=400&fit=crop'
    }],
    estimatedRefundDate: '2024-01-18'
  }, {
    id: '#RET-2025-00010',
    originalOrderId: '#000013945',
    returnDate: '2024-01-08',
    status: 'rejected' as const,
    reason: 'Changed mind',
    refundMethod: 'N/A',
    refundAmount: 0,
    items: [{
      name: 'Digital Blood Pressure Monitor',
      quantity: 1,
      price: 89.99,
      image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400&h=400&fit=crop'
    }]
  }];
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'approved':
        return 'bg-green-100 text-green-700';
      case 'pending':
        return 'bg-yellow-100 text-yellow-700';
      case 'rejected':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const handleViewDetails = (returnItem: any) => {
    setSelectedReturn(returnItem);
    setIsModalOpen(true);
  };
  return <>
      <div className="space-y-6" data-id="element-1137" data-mp="3qvm2e9qqzv9o">
        <div className="flex items-center justify-between" data-id="element-1138" data-mp="3qukozym9ewos">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-1139" data-mp="3mukayf32oni9">Returns & Refunds</h2>
        </div>
        {returns.length === 0 ? <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-12 text-center" data-id="element-1140" data-mp="4nmil9ed47al">
            <PackageIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-1141" data-mp="3vw0d5zjqhjbe" />
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1142" data-mp="26fiqm91bmz0m">
              No returns yet
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-1143" data-mp="21hr1tnvz3t0n">You haven't made any returns</p>
          </div> : <div className="space-y-4" data-id="element-1144" data-mp="gzy9udia9r00">
            {returns.map(returnItem => <div key={returnItem.id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1145" data-mp="lyjauf5d0epi">
                <div className="bg-[#1E2B55] text-white px-6 py-4 flex items-center justify-between" data-id="element-1146" data-mp="779aui3x65lk">
                  <div data-id="element-1147" data-mp="3udta7fhv75tl">
                    <h3 className="text-lg font-bold" data-id="element-1148" data-mp="3uda2sspubztt">{returnItem.id}</h3>
                    <p className="text-sm text-blue-200" data-id="element-1149" data-mp="37ielyvmix9n">
                      Original Order: {returnItem.originalOrderId}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-1150" data-mp="3khgfqfehwnxs">
                    <p className="text-sm text-blue-200" data-id="element-1151" data-mp="3pe6y59drvvmd">Refund Amount</p>
                    <p className="text-2xl font-bold" data-id="element-1152" data-mp="3pgjlk22auy6t">
                      SAR {returnItem.refundAmount.toFixed(2)}
                    </p>
                  </div>
                </div>
                <div className="p-6 space-y-4" data-id="element-1153" data-mp="1nl98fmfalj5n">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1154" data-mp="3jqruxax31bn8">
                    <div data-id="element-1155" data-mp="3fp6a93eb3t2h">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-1156" data-mp="3fpy68fbtfsta">Return Date</p>
                      <p className="text-sm font-semibold text-gray-900" data-id="element-1157" data-mp="3apah5z75dm1p">
                        {new Date(returnItem.returnDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  })}
                      </p>
                    </div>
                    <div data-id="element-1158" data-mp="2rzkaadq419tf">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-1159" data-mp="2n07qy2yg6kvl">Status</p>
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${getStatusBadge(returnItem.status)}`} data-id="element-1160" data-mp="2n22959ic3yvz">
                        {returnItem.status.charAt(0).toUpperCase() + returnItem.status.slice(1)}
                      </span>
                    </div>
                    <div data-id="element-1161" data-mp="27vwjt4xa6c67">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-1162" data-mp="27zancghokrf8">Reason</p>
                      <p className="text-sm font-semibold text-gray-900" data-id="element-1163" data-mp="2cxlwsq42czwx">
                        {returnItem.reason}
                      </p>
                    </div>
                    <div data-id="element-1164" data-mp="1k856by007t3c">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-1165" data-mp="1k8y5acsq1eax">
                        Refund Method
                      </p>
                      <p className="text-sm font-semibold text-gray-900" data-id="element-1166" data-mp="1p4lxl12i2nkn">
                        {returnItem.refundMethod}
                      </p>
                    </div>
                  </div>
                  <div data-id="element-1167" data-mp="1yym7rhcn2j08">
                    <p className="text-xs text-gray-600 mb-2" data-id="element-1168" data-mp="11h5gyvolkh9j">Items</p>
                    <ul className="text-sm text-gray-700 list-disc list-inside" data-id="element-1169" data-mp="11f1cabivje87">
                      {returnItem.items.map((item: any, index: number) => <li key={index} data-id="element-1170" data-mp="yehdx1i59emh" data-mpi={index}>{item.name}</li>)}
                    </ul>
                  </div>
                  <button onClick={() => handleViewDetails(returnItem)} className="w-full bg-[#1E2B55] text-white font-bold py-3 rounded-lg hover:bg-[#162041] transition-colors" data-id="element-1171" data-mp="tg63aok0z037">
                    View Details
                  </button>
                </div>
              </div>)}
          </div>}
      </div>
      {selectedReturn && <ReturnDetailsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} returnData={selectedReturn} data-id="element-1172" data-mp="ajoi6pzolyfx" />}
    </>;
}